import { render, staticRenderFns } from "./qyxw.vue?vue&type=template&id=6c6a3448&scoped=true&"
import script from "./qyxw.vue?vue&type=script&lang=js&"
export * from "./qyxw.vue?vue&type=script&lang=js&"
import style0 from "./qyxw.vue?vue&type=style&index=0&id=6c6a3448&scoped=true&lang=css&"
import style1 from "./qyxw.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6a3448",
  null
  
)

export default component.exports